import { render, staticRenderFns } from "./UserLogsSystem.vue?vue&type=template&id=4cdc9464"
import script from "./UserLogsSystem.vue?vue&type=script&lang=js"
export * from "./UserLogsSystem.vue?vue&type=script&lang=js"
import style0 from "./UserLogsSystem.vue?vue&type=style&index=0&id=4cdc9464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports